
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_mgja0_spdal_153",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_mgja0_spdal_1",
  "root": "awsui_root_mgja0_spdal_176",
  "wide": "awsui_wide_mgja0_spdal_207",
  "focus-lock": "awsui_focus-lock_mgja0_spdal_214",
  "trigger-flexbox": "awsui_trigger-flexbox_mgja0_spdal_218",
  "calendar-container": "awsui_calendar-container_mgja0_spdal_222",
  "one-grid": "awsui_one-grid_mgja0_spdal_225",
  "calendar-header": "awsui_calendar-header_mgja0_spdal_229",
  "calendar-header-pages-wrapper": "awsui_calendar-header-pages-wrapper_mgja0_spdal_235",
  "calendar-header-page": "awsui_calendar-header-page_mgja0_spdal_235",
  "date-and-time-container": "awsui_date-and-time-container_mgja0_spdal_255",
  "date-and-time-wrapper": "awsui_date-and-time-wrapper_mgja0_spdal_261",
  "footer": "awsui_footer_mgja0_spdal_268",
  "has-clear-button": "awsui_has-clear-button_mgja0_spdal_277",
  "footer-button-wrapper": "awsui_footer-button-wrapper_mgja0_spdal_286",
  "icon-wrapper": "awsui_icon-wrapper_mgja0_spdal_293",
  "label": "awsui_label_mgja0_spdal_298",
  "label-enabled": "awsui_label-enabled_mgja0_spdal_302",
  "label-text": "awsui_label-text_mgja0_spdal_306",
  "label-token-nowrap": "awsui_label-token-nowrap_mgja0_spdal_311",
  "dropdown": "awsui_dropdown_mgja0_spdal_315",
  "dropdown-content": "awsui_dropdown-content_mgja0_spdal_337"
};
  